var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBadminton({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M2.418 9.842c.556.205 1.091.54 1.607 1.003.515.463.967.987 1.354 1.57l-.937 1.079a1.962 1.962 0 0 1-2.96-2.574l.936-1.078z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M2.418 9.842c.556.205 1.091.54 1.607 1.003.515.463.967.987 1.354 1.57l-.796.917c-.57-1.21-1.559-2.079-2.853-2.699l.688-.791z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M4.726 11.562c.2.221.418.506.653.854l-.796.916c-.17-.36-.376-.69-.617-.991l.02-.02c.12-.12.685-.701.74-.76z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M4.413 10.766a7.395 7.395 0 0 0-.02-.02l1.354-1.16c.063.068.123.137.18.205L4.605 10.96a7.284 7.284 0 0 0-.192-.193zM6.396 9.03l5.63-4.826c.124-.082.194.023.09.12l-5.54 4.893-.18-.187zm-2.597 1.207L4.85 8.813c.073.052.146.106.219.162l-1.037 1.449a6.437 6.437 0 0 0-.234-.187zm5.967-8.074c.101-.108.193-.021.113.097L5.583 8.258a11.433 11.433 0 0 0-.197-.169l4.38-5.926zm-6.742 7.59l.76-1.64c.067.047.14.095.217.144l-.728 1.627a3.386 3.386 0 0 0-.25-.13zM4.17 7.282L7.131.9c.077-.127.184-.061.131.071L4.391 7.386a2.377 2.377 0 0 0-.22-.104zm3.31.631c-.085-1.505 1.015-2.752 2.684-3.875.737-.63 1.282.081 1.683.074L7.48 7.913zM6.158 6.827c-.421-1.447.37-2.91 1.744-4.379.576-.78 1.267-.21 1.656-.307l-3.4 4.686zm-1.59-.66c-.712-1.329-.243-2.923.796-4.646.401-.883 1.195-.469 1.556-.645l-2.352 5.29zM9.12 8.15l-.131.04c-.407.125-.703.191-1.152.102l4.372-3.795c-.063.396.565 1.034-.162 1.676-.332-.004-2.252.886-2.928 1.977zm-3.867 3.6l1.466-.836c.055.083.107.16.158.226l-1.466.864a3.945 3.945 0 0 0-.158-.254zm2.273-1.295l6.328-3.605c.137-.057.185.059.065.135l-6.293 3.713a1.628 1.628 0 0 0-.1-.243z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M8.684 9.623c.204-1.494 1.52-2.508 3.374-3.292.844-.477 1.243.324 1.638.394L8.684 9.623zm.278.44l5.015-2.891c-.137.377.357 1.123-.478 1.615-1.605 1.213-3.142 1.846-4.537 1.276zM7.5 6.878c-.318.131-.562.281-.917.292L9.99 2.49c.024.355.679.613.42 1.254-.325-.024-2.72 1.8-2.91 3.135zM5.885 5.86c-.283.196-.49.393-.835.478L7.408 1.05c.098.342.77.43.716.99-.324.045-2.33 2.475-2.24 3.82z"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#DF0411",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    opacity: 0.25,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M5.676 9.201c-1.041-1.005-2.134-1.44-2.06-1.66.064-.252 1.242.403 2.283 1.409 1.041 1.005 1.75 2.15 1.487 2.232-.205.076-.669-.975-1.71-1.98z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadminton);
export default __webpack_public_path__ + "static/media/badminton.2fa09056ce81f5b8901a82b12a445965.svg";
export { ForwardRef as ReactComponent };